import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { onMounted } from 'vue';
import { AppStore } from '@apparatix/stores/AppStore';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PageNotImplemented',
    setup(__props) {
        onMounted(() => AppStore.isFrameLoading = false);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("h1", null, "This page is not yet implemented"));
        };
    }
});
